import React from 'react'
import { SecondaryHeader } from '@grammarly/website-components'

import { HeaderGlobal } from '.'
import { getConfig } from '../../../../config'

import styles from './global.module.scss'

interface HeaderGlobalProps {
  ctas?: React.ReactNode
}

export const HeaderGlobalTools: React.FC<HeaderGlobalProps> = (props) => {
  return <HeaderGlobal secondaryHeader={<SecondaryToolsHeader />} ctas={props.ctas} />
}

const baseUrl = getConfig().urls.main

const toolsHeaderContent = [
  {
    label: 'Grammar Check',
    href: `${baseUrl}/grammar-check`,
  },
  {
    label: 'Plagiarism Checker',
    href: `${baseUrl}/plagiarism-checker`,
  },
  {
    label: 'Citation Generator',
    href: `${baseUrl}/citations`,
  },
  {
    label: 'Paraphrasing Tool',
    href: `${baseUrl}/paraphrasing-tool`,
  },
]

const ToolsHeaderLogo = () => {
  return (
    <div className={styles.toolsHeaderLogo}>
      <svg xmlns="http://www.w3.org/2000/svg" width="53" height="16" fill="none">
        <path
          fill="#161719"
          d="M.71 2.99V.455h11.946V2.99H8.203V15h-3.04V2.99H.71Zm17.204 12.223c-3.31 0-5.37-2.266-5.37-5.625 0-3.38 2.06-5.64 5.37-5.64s5.369 2.26 5.369 5.64c0 3.36-2.06 5.625-5.37 5.625Zm.014-2.344c1.498 0 2.28-1.399 2.28-3.302 0-1.904-.781-3.31-2.28-3.31-1.527 0-2.308 1.406-2.308 3.31 0 1.903.78 3.302 2.308 3.302Zm12.251 2.344c-3.31 0-5.369-2.266-5.369-5.625 0-3.38 2.06-5.64 5.37-5.64 3.309 0 5.369 2.26 5.369 5.64 0 3.36-2.06 5.625-5.37 5.625Zm.015-2.344c1.498 0 2.28-1.399 2.28-3.302 0-1.904-.782-3.31-2.28-3.31-1.527 0-2.309 1.406-2.309 3.31 0 1.903.781 3.302 2.308 3.302ZM40.541.455V15h-3.026V.455h3.026Zm11.5 6.747-2.77.17c-.15-.703-.774-1.278-1.825-1.278-.938 0-1.676.426-1.67 1.08-.006.525.37.873 1.386 1.093l1.974.398c2.117.433 3.146 1.378 3.154 2.954-.008 2.152-2.032 3.594-4.858 3.594-2.891 0-4.667-1.285-4.95-3.373l2.975-.157c.185.888.902 1.35 1.982 1.35 1.058 0 1.761-.462 1.775-1.108-.014-.547-.447-.895-1.399-1.087l-1.89-.376c-2.13-.426-3.16-1.485-3.153-3.118-.007-2.103 1.833-3.395 4.624-3.395 2.756 0 4.375 1.243 4.645 3.253Z"
        />
      </svg>
    </div>
  )
}

const SecondaryToolsHeader = () => {
  return <SecondaryHeader LogoComponent={ToolsHeaderLogo} content={toolsHeaderContent} />
}
